"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  emptyTargetTip: '请从左侧列表选择',
  emptySourceTip: '暂无资源',
  emptySearchTip: '当前搜索或筛选结果为空',
  resetSearch: '重置列表',
  sourceTitle: '可选',
  targetTitle: '已选'
};
exports.default = _default;